import { api_base } from "../rgs_modules/rgs.base";
import { api_108_json_request, api_108_json_response, api_108_json_response_network, api_108_resume } from "./json";
import { getSessionResponse, GSAPI_CALL_NAME, regClientResponse, regRoundResponse, regStepResponse, serverError } from "../Csi/csi.types";
import { BalanceManager } from "../utils/balanceManager";
import { api_108_transport } from "./rgs.108.transport";
import { keepAlive } from "../utils/settings/keepAlive";
import { requestBalance } from "../utils/settings/requestBalance";

export class api_108 extends api_base{
    public readonly API_VERSIONS: string[] = ["1.08"];
    
    protected readonly LOG_LEVEL: number = 1;
    protected readonly LOG_PREFIX: string = '*** RGS(1.08): ';

    public response: api_108_json_response | null = null;

    protected serverUID: number | undefined;

    protected clientUID: string = "";

    public requestToken: string = "";

    protected serverHost: string = "";

    public gameLanguage = "en_EN";
    
    private game:any;

    public transport : api_108_transport;

    public keepAlive: keepAlive;

    public requestBalance: requestBalance
    
    constructor(gameKey: string, gameUID: string, params: any, game: any) {
        super(gameKey, gameUID, params);
        this.game = game;
        this.checkAPIVersion();

        this.transport = new api_108_transport(this, game)
        this.keepAlive = new keepAlive(this.params, this.transport)
        this.requestBalance = new requestBalance(this.params)
    }

    public get modeNext(): number {
        let modeNext = 0;
        if (this.response) {
            if (this.response.init) {
                modeNext = this.response.init.next;
            } else if (this.response.play) {
                modeNext = this.response.play.next;
            }
        }
        return modeNext;
    }

    private requestUrlCreation(params: any, requestURL: any): string{
        if (params.session) {
            requestURL += "&session=" + this.setEncodeParam(params.session);
        }
        if (params.network) {
            requestURL += "&network=" + this.setEncodeParam(params.network);
        }
        if (params.operator) {
            requestURL += "&operator=" + this.setEncodeParam(params.operator);
        }
        if(params.mode){
            requestURL += "&mode=" + this.setEncodeParam(params.mode)
        }
        if (params.language) {
            requestURL += "&language=" + this.setEncodeParam(params.language);
        }
        if (params.currency) {
            requestURL += "&currency=" + this.setEncodeParam(params.currency);
        }
        if (params.device) {
            requestURL += "&device=" + this.setEncodeParam(params.device);
        } else {       
            requestURL += "&device=desktop"; 
        }
        if (params.debug) {
            requestURL += "&debug=" + this.setEncodeParam(params.debug)
        }
        if(params.serverAPI){
            requestURL += "&gsapi=" + this.setEncodeParam(params.serverAPI);
        }
        if(params.engineApi){
            requestURL += "&geapi=" + this.setEncodeParam(params.engineApi)
        }
        if(params.serverVersion){
            requestURL += "&gsver=" + this.setEncodeParam(params.serverVersion)
        }
        if (params.promotion) {
            requestURL += "&promotion=" + this.setEncodeParam(params.promotion);
        }
        if(params.env){
            requestURL += "&env=" + this.setEncodeParam(params.env)
        }

        requestURL += "&referer=" + this.setEncodeParam(window.location.href)  //this.setEncodeParam("https://demo.mongibello.tech/games/tortuga-DEV/?debug=true&game=tortuga-DEV&mode=real&network=base&operator=base&session=6e6ace840fb767b8be8fcd21dede6f24&language=it_IT&currency=EUR&jurisdiction=it&lobby=http%3A%2F%2Fdemo.mongibello.tech%2Fgames%2F%3Fdo%3Dexit%26session%3D6e6ace840fb767b8be8fcd21dede6f24&gsh=demo.mongibello.tech%2FgadM&env=develop&geapi=1.07&gsapi=1.07&gsver=1.07&launching=http%3A%2F%2Fdemo.mongibello.tech%2Fsystem%2Fnetworks%2Fbase%2Flauncher%2F%3Fgame%3Dtortuga-DEV%26debug%3Dtrue%26network%3Dbase%26operator%3Dbase%26language%3Dit_IT%26jurisdiction%3Dit%26currency%3DEUR%26session%3D6e6ace840fb767b8be8fcd21dede6f24%26mode%3Dreal%26lobby%3Dhttp%3A%2F%2Fdemo.mongibello.tech%2Fgames%2F%253fdo%3Dexit%2526session%3D6e6ace840fb767b8be8fcd21dede6f24)"); //https%3A%2F%2Fdemo.mongibello.tech%2Fgames%2Fcrashbase-DEV%2F%3Fdebug%3Dtrue%26game%3Dcrashbase-DEV%26mode%3Dreal%26network%3Dbase%26operator%3Dbase%26session%3De1db9015efa16c729204d98aa7833973%26language%3Dit_IT%26currency%3DEUR%26jurisdiction%3Dit%26lobby%3Dhttp%253A%252F%252Fdemo.mongibello.tech%252Fgames%252F%253Fdo%253Dexit%2526session%253De1db9015efa16c729204d98aa7833973%26gsh%3Ddemo.mongibello.tech%252FgadM%26env%3Ddevelop%26geapi%3D2.0%26gsapi%3D1.08%26gsver%3D1.08%26launching%3Dhttp%253A%252F%252Fdemo.mongibello.tech%252Fsystem%252Fnetworks%252Fbase%252Flauncher%252F%253Fgame%253Dcrashbase-DEV%2526debug%253Dtrue%2526network%253Dbase%2526operator%253Dbase%2526language%253Dit_IT%2526jurisdiction%253Dit%2526currency%253DEUR%2526session%253De1db9015efa16c729204d98aa7833973%2526mode%253Dreal%2526lobby%253Dhttp%253A%252F%252Fdemo.mongibello.tech%252Fgames%252F%25253fdo%3Dexit%252526session%253De1db9015efa16c729204d98aa7833973" //https://eva.rgs106.com/games/hkingdom-XYY/2.00/?debug=true&game=hkingdom-D16&mode=real&network=base&operator=base&session=fbaebda5155cd72ba94975d3ffb33ae1&jurisdiction=es&language=it_IT&currency=EUR&lobby=http%3A%2F%2Feva.rgs106.com%2Fgames%2F%3Fdo%3Dexit%26session%3Dfbaebda5155cd72ba94975d3ffb33ae1&env=develop&geapi=1.04&gsapi=1.08&gsver=1.08&launching=http%3A%2F%2Feva.rgs106.com%2Fsystem%2Fnetworks%2Fbase%2Flauncher%2F%3Fgame%3Dhkingdom-D16%26debug%3Dtrue%26network%3Dbase%26operator%3Dbase%26language%3Dit_IT%26jurisdiction%3Des%26currency%3DEUR%26session%3Dfbaebda5155cd72ba94975d3ffb33ae1%26mode%3Dreal%26lobby%3Dhttp%3A%2F%2Feva.rgs106.com%2Fgames%2F%253fdo%3Dexit%2526session%3Dfbaebda5155cd72ba94975d3ffb33ae1" 

        return requestURL;
    }
    /**
     * Set RGS API Error
     * @param code    Code error
     * @param text    Text error
     */
    public setError(code: serverError, text?: string): void {
        this.error.code = code;
        this.error.text = text;
    }


    public async logEventAsync(type: number, data?: object, gn_data?: any, clientUID?: any, requestToken?: any): Promise<void>{
        if (!clientUID) {
            this.setError(serverError.CALL_PARAM_CLIENT);
            return;
        }
        if (!requestToken) {
            this.setError(serverError.CALL_PARAM_TOKEN);
            return;
        }

        let requestURL = this.serverBaseURL + GSAPI_CALL_NAME.LOG_EVENT + "?client=" + this.setEncodeParam(clientUID)
        
        const requestData = {
            t: requestToken,
            e: {
                t: type,
                d: data ?? {m:"generic error"}
            }
        };

        try {
            await this.transport.callSilent(GSAPI_CALL_NAME.LOG_EVENT, requestURL, requestData, 3000);
            console.log("✅ LOG_EVENT inviato con successo");
        } catch (error) {
            console.warn("❌ Errore nell'invio di LOG_EVENT", error);
        }
    }

    public async getSessionAsync(params: any): Promise<getSessionResponse> {
        let requestURL = this.serverBaseURL + GSAPI_CALL_NAME.GET_SESSION + "?game=" + this.setEncodeParam(this.gameUID)
        requestURL = this.requestUrlCreation(params, requestURL)
        try {
            const response = await this.transport.call2(GSAPI_CALL_NAME.GET_SESSION, requestURL, null, 0, 10000, 'POST')
            
            if(this.response?.error){
                const err = new Error(`GET SESSION: risposta vuota url: ${requestURL}, code: ${this.response?.error}`);
                throw err
            }
            
            this.params.serverHost = this.response!.serverHost
            
            return {
                serverHost: this.response!.serverHost
            };
        } catch (err: any) {
            this.keepAlive.keepAlivePingStop();
            this.requestBalancePingStop();
            console.error("❌ Errore nella getSessionAsync:", err);
            const e = err instanceof Error ? err : new Error(String(err));
            e.message = `getSession: ${e.message} | url=${requestURL}`;
            throw e;
        }
    }

    public async getDataAsync(): Promise<any>{
        const balanceRequestURL = this.serverBaseURL + GSAPI_CALL_NAME.GET_DATA + "?client=" + this.setEncodeParam(this.clientUID) + "&request=balance";
        try{       
            const balanceReqData = new api_108_json_request(this.requestToken);

            const balanceResponse = await this.transport.call2(GSAPI_CALL_NAME.GET_DATA, balanceRequestURL, balanceReqData); //chiama il balance con il getdata

            BalanceManager.set(balanceResponse.c);

            (window as any).UIBridge?.setBalance((window as any).FORMATTER.formatCurrency(balanceResponse.c, true));
            
            this.requestToken = balanceResponse.t;

            return balanceResponse

        } catch(err: any){
            this.keepAlive.keepAlivePingStop();
            this.requestBalancePingStop();
            console.error("❌ Errore nella getDataAsync:", err);
            const e = err instanceof Error ? err : new Error(String(err));
            e.message = `getSession: ${e.message} | url=${balanceRequestURL}`;
            throw e;
        }
    }

    public async regClientAsync(params: any): Promise<regClientResponse> {
        this.checkAPIVersion();
        let requestURL = this.serverBaseURL + GSAPI_CALL_NAME.REG_CLIENT + "?game=" + this.setEncodeParam(this.gameUID)
        requestURL = this.requestUrlCreation(params, requestURL)

        try {
            //await this.debugErrorCall("generic");
            const json = await this.transport.call2(GSAPI_CALL_NAME.REG_CLIENT, requestURL, null, 0, 10000, 'POST')
            
            if(this.response?.error){
                const err = new Error(`Reg Round: risposta vuota url: ${requestURL}, code: ${this.response?.error}`);
                throw err
            }

            // salva localmente se ti serve
            this.clientUID = this.response!.init.client;
            this.requestToken = this.response!.token;
            const credits = this.response!.credits.total
            const server = this.response!.init.server;
            const pendingRound = this.response!.init.pending_round;
            const mode = this.response!.init.mode;
            const data = this.response!.init.data;
            const next = this.response!.init.next;
            const value = this.response!.init.win?.value || 0;
            const total = this.response!.init.win?.total || 0;
            const coinStep = this.response!.init.data.c?.g?.b?.c ?? this.response!.init.data.betConfigurations?.game?.availableBets?.coins;
            const incrementStep = this.response!.init.data.c?.g?.b?.i ?? this.response!.init.data.betConfigurations?.game?.availableBets?.incrementLevels ?? 0;
            const error = this.response!.error;
            const resume = new api_108_resume(this.response!.init.resume.status, this.response!.init.resume.list);


            // Recupero balance subito dopo
            const balanceResponse = await this.getDataAsync(); //chiama il balance con il getdata

            const formattedCoinStep = coinStep.map((coin: number) =>
                (window as any).FORMATTER.formatCurrency(coin, true)
            );
            (window as any).UIBridge?.setCoinStep(coinStep, formattedCoinStep);
            // (window as any).UIBridge?.setIncrementStep(incrementStep);
            // Inietto i credits nel response principale (per compatibilità)
            const balance = balanceResponse?.c || { t: 0, b: 0 };

            this.gameLanguage = this.setEncodeParam(params.language);

            return {
                error: error, 
                credits: credits,
                pending_round: pendingRound,
                resume: resume,
                mode: mode,
                data: data,
                next: next,
                win: {
                    value: value,
                    total: total
                },
                clientUID: this.clientUID,
                clientToken: balanceResponse.t,
                init: json.i,
                balance: balance,
                serverUID: server
            };
        } catch (err: any) {
            this.keepAlive.keepAlivePingStop();
            this.requestBalancePingStop();
            console.error("❌ Errore nella regClientAsync:", err);
            const e = err instanceof Error ? err : new Error(String(err));
            e.message = `RegClient: ${e.message} | url=${requestURL}`;
            throw e;
        }
    }

    public async regRoundAsync(gamble: boolean, bet: any, gn_data: any = null, clientUid: any, clientTokenForRequest: any, cheat: any): Promise<regRoundResponse>{
        this.bet = bet;
        const requestURL = this.serverBaseURL + GSAPI_CALL_NAME.REG_ROUND + "?client=" + this.setEncodeParam(clientUid);
        const requestData = new api_108_json_request(clientTokenForRequest, gn_data, this.gameKey, bet, 0, null, false, false, false, false, cheat);
        this.clientUID = clientUid;
        try{
            //await this.debugErrorCall("http");

            const response = await this.transport.call2(GSAPI_CALL_NAME.REG_ROUND, requestURL, requestData);

            if (this.error.code !== 0 || !this.response) {
                throw new Error(`RegRound: empty response | url=${requestURL} | code=${this.response?.error}`);
            }

            BalanceManager.set(response.c);
            
            (window as any).UIBridge?.setBalance((window as any).FORMATTER.formatCurrency(response.c, true)); // Formatter.formatCurrency(response.c, true));
            
            const result: regRoundResponse = {
                credits: this.response.credits.total,
                bet: this.bet, // puoi eventualmente cambiare con this.response.bet se il GS lo supporta
                data: this.response.data,
                token : response.t,
                balance: response.c
            };
            this.requestToken = response.t;
            clientTokenForRequest = response.t;
  
            return result;
        } catch(err: any){
            this.keepAlive.keepAlivePingStop();
            this.requestBalancePingStop();
            if (err.name === "AbortError") {
                console.error("regRoundAsync timeout:", err);
                throw err;
            }

            const e = err instanceof Error ? err : new Error(String(err));
            console.error("❌ Errore nella regroundAsync:", e.message, e.stack);
            this.game.pause(true)
            throw e;
        }        
    }

    public async regStepAsync(mode: number, bet: any, data: any, gn_data: any, cheat: any, clientUid: any, clientTokenForRequest: any): Promise<regStepResponse>{
        const requestURL = this.serverBaseURL + GSAPI_CALL_NAME.REG_STEP + "?client=" + this.setEncodeParam(clientUid);
        //const requestBet = this.gsGambleChoice ? bet : null;
        const requestBet = null;
        let requestCheat = cheat;
        
        console.log("📤 Cheat completo inviato a regStepAsync:", JSON.stringify(cheat, null, 2));

        //Passo il client per tutte le funzioni
        this.clientUID = clientUid;
        this.requestToken = clientTokenForRequest;
        
        
        const requestData = new api_108_json_request(this.requestToken, gn_data, this.gameKey, null, mode, data, false, false, requestBet, false, requestCheat);
        try {
            const response = await this.transport.call2(GSAPI_CALL_NAME.REG_STEP, requestURL, requestData);
            requestCheat = undefined;
            cheat = undefined;
            (window as any).UIBridge?.resetCheat()
            if (!this.response?.data) {
                const err = new Error(`Reg Step: risposta vuota url: ${requestURL}, code: ${this.response?.error}`);
                throw err
            }
            
    
            const result: regStepResponse = {
                credits: this.response.credits.total,
                data: this.response.data.data,
                next: this.response.data.next,
                win: {
                    value: this.response.data.win.value,
                    total: this.response.data.win.total
                },
                error: this.response.error,
                token : response.t,
                balance : response.c
            };
            this.requestToken = response.t; //token che serve per la chiamata successiva
            
            return result;
    
        } catch (err: any) {
            this.keepAlive.keepAlivePingStop();
            this.requestBalancePingStop();
            if (err.name === "AbortError") {
                console.error("regRoundAsync timeout:", err);
                throw err;
            }

            const e = err instanceof Error ? err : new Error(String(err));
            console.error("❌ Errore nella regstepAsync:", e.message, e.stack);
            this.game.pause(true)

            throw e;
        }
    } 

    public async endRound(clientTokenForRequest: any): Promise<any> { //utile solo con rgs1.08
        console.log("📞 CALLER.endRoundAsync chiamato! 1.08");
    
        const requestURL = this.serverBaseURL + "end_round?client=" + this.setEncodeParam(this.clientUID);
        this.requestToken = clientTokenForRequest; // Aggiorna il token prima della chiamata a endRound
        const requestData = new api_108_json_request(this.requestToken, this.gameKey);
    
        try {
            const json = await this.transport.call2(GSAPI_CALL_NAME.END_ROUND, requestURL, requestData);
            
            if (!json) {
                throw new Error("Risposta vuota da end_round");
            }

            if (this.error.code !== 0 || json?.e) {
                throw new Error(`EndRound: error response | url=${requestURL} | code=${json?.e ?? this.response?.error ?? this.error.code}`);
            }
    
            // Aggiorna eventuali stati interni se necessario
            if (json?.t) {
                this.requestToken = json.t;
            }
    
            return json;
        } catch (err: any) {
            this.keepAlive.keepAlivePingStop();
            this.requestBalancePingStop();
            if (err.name === "AbortError") {
                console.error("regRoundAsync timeout:", err);
                throw err;
            }

            const e = err instanceof Error ? err : new Error(String(err));
            console.error("❌ Errore in endRoundAsync:", e.message, e.stack);
            this.game.pause(true)
            throw e;
        }
    }

    //TODO REFACTORING
    public async endStep(clientTokenForRequest: any): Promise<void> {
        const requestURL = this.serverBaseURL + GSAPI_CALL_NAME.END_STEP + "?client=" + this.setEncodeParam(this.clientUID);
        this.requestToken = clientTokenForRequest; // Aggiorna il token prima della chiamata a endStep
        const requestData = new api_108_json_request(this.requestToken, null, this.gameKey);

        try {
            const json = await this.transport.call2(GSAPI_CALL_NAME.END_STEP, requestURL, requestData);

            if (!json) {
                throw new Error("Risposta vuota da end_step");
            }

            if (this.error.code !== 0 || json?.e) {
                throw new Error(`EndStep: error response | url=${requestURL} | code=${json?.e ?? this.response?.error ?? this.error.code}`);
            }

            if (json?.t) {
                this.requestToken = json.t;
            }

            if (this.response != null) {
                // Evita una doppia gestione dei payload network dopo reg_step.
                this.response.network = new api_108_json_response_network(null);
            }

            this.lastCall = GSAPI_CALL_NAME.END_STEP;
            return json;
        } catch (err: any) {
            this.keepAlive.keepAlivePingStop();
            this.requestBalancePingStop();

            if (err.name === "AbortError") {
                console.error("endStepAsync timeout:", err);
                throw err;
            }

            const e = err instanceof Error ? err : new Error(String(err));
            console.error("❌ Errore in endStepAsync:", e.message, e.stack);
            this.game.pause(true);
            throw e;
        }
    }

    //TODO REFACTORING
    /*public end_client(callback: any, expired: boolean, gn_data: any = null) {
        if ((this.clientUID) && (this.requestToken)) {
            const requestURL  = this.serverBaseURL + GSAPI_CALL_NAME.END_CLIENT + "?client=" + this.setEncodeParam(this.clientUID);
            const requestData = new api_108_json_request(this.requestToken, gn_data, this.gameKey, null, 0, null, false, false, null, expired);
            this.call(GSAPI_CALL_NAME.END_CLIENT, requestURL, requestData, ((json: any) => {
                this.exeCallback(callback);
            }).bind(this));
        } else {
            this.setError((!this.clientUID) ? serverError.CALL_PARAM_CLIENT : serverError.CALL_PARAM_TOKEN);
            this.exeCallback(callback);
        }
    }*/

    public keepAlivePingStart(): void {
        this.keepAlive.keepAlivePingStart();
    }

    public keepAlivePingStop(): void {
        this.keepAlive.keepAlivePingStop();
    }
    
    public requestBalancePingStart(): void{
        this.requestBalance.requestBalancePingStart();
    }

    public requestBalancePingStop(): void{
        this.requestBalance.requestBalancePingStop();
    }
}
